import { render, staticRenderFns } from "./addAuth.vue?vue&type=template&id=c624ccfa&scoped=true"
import script from "./addAuth.vue?vue&type=script&lang=js"
export * from "./addAuth.vue?vue&type=script&lang=js"
import style0 from "./addAuth.vue?vue&type=style&index=0&id=c624ccfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c624ccfa",
  null
  
)

export default component.exports